import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "date",
  "use": "date-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"date\"><defs><style>#date .cls-1{fill:none}</style></defs><title>资源 1</title><g id=\"date_图层_2\" data-name=\"图层 2\"><g id=\"date_Group_149\" data-name=\"Group 149\"><path id=\"date_Rectangle_45_Copy_5\" data-name=\"Rectangle 45 Copy 5\" class=\"cls-1\" d=\"M0 0h24v24H0z\" /><g id=\"date_calendar\"><path id=\"date_Shape\" d=\"M3.19 22.5a1.69 1.69 0 0 1-1.69-1.69V4.69A1.69 1.69 0 0 1 3.19 3H6v-.66a.85.85 0 0 1 1.69 0V3h8.62v-.66a.85.85 0 0 1 1.69 0V3h2.82a1.69 1.69 0 0 1 1.68 1.69v16.12a1.69 1.69 0 0 1-1.69 1.69zm0-1.69h17.62V9H3.19zm0-13.5h17.62V4.69H18v.47a.85.85 0 0 1-1.69 0v-.47H7.69v.47a.85.85 0 0 1-1.69 0v-.47H3.19zm8.06 10.74a.75.75 0 0 1 0-1.5h1.5a.75.75 0 0 1 0 1.5zm-4.5 0a.75.75 0 0 1 0-1.5h1.5a.75.75 0 0 1 0 1.5zm9-4.55a.75.75 0 0 1 0-1.5h1.5a.75.75 0 0 1 0 1.5h-1.5zm-4.5 0a.75.75 0 0 1 0-1.5h1.5a.75.75 0 0 1 0 1.5zm-4.5 0a.75.75 0 0 1 0-1.5h1.5a.75.75 0 0 1 0 1.5z\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/date.svg
// module id = iEN+
// module chunks = 6